import {
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';
import { MaterialCreatableInterface } from '../interfaces/material-creatable.interface';
import { MaterialCascadableInterface } from '../interfaces/material-cascadable.interface';
import { MaterialNameWhitelistAmountValidator } from '../enums/material-name-whitelist-amount-validator.enum';

interface MaterialAllowZeroAmountValue
  extends MaterialCreatableInterface,
    MaterialCascadableInterface {}

@ValidatorConstraint({ name: 'materialAllowZeroAmount', async: false })
export class MaterialAllowZeroAmountValidator
  implements ValidatorConstraintInterface
{
  validate(materials: MaterialAllowZeroAmountValue[]) {
    const whitelistMaterialNames = Object.values(
      MaterialNameWhitelistAmountValidator,
    ) as string[];

    // validate all materials in allowed list, if is present we let be zero values, otherwise require to be greater than 0
    return materials.every(
      ({ name, amount }) => whitelistMaterialNames.includes(name) || amount > 0,
    );
  }

  defaultMessage() {
    return 'Amount must be positive, except for Mud and Tape where it can be zero.';
  }
}
